import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Table } from '@layout/DashboardTable';
import { getNewOrder } from '@services/dashboardResource';
import DashboardTableHead from './DashboardTableHead';
import DashboardTableRow from './DashboardTableRow';

export class DashboardTable extends PureComponent {
  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.object),
    order: PropTypes.string.isRequired,
    setOrder: PropTypes.func.isRequired,
  };

  static defaultProps = {
    list: [],
  };

  sortBy = ({ currentTarget: { name } }) => {
    const { order, setOrder, sortByOrder } = this.props;
    setOrder('order', getNewOrder(order, name));
    setTimeout(sortByOrder);
  };

  render() {
    const { list, order } = this.props;
    return (
      <Table id="dashboard-table">
        <DashboardTableHead {...this.props} order={order} sortBy={this.sortBy} />
        <tbody>
          {list.map((item) => (
            <DashboardTableRow {...this.props} key={item.id} {...item} />
          ))}
        </tbody>
      </Table>
    );
  }
}

export default DashboardTable;



// WEBPACK FOOTER //
// ./components/organisms/DashboardTable/DashboardTable.js